export const ORDER_SUBSCRIPTIONS = 'moi/simCards/ORDER_SUBSCRIPTIONS';
export const ORDER_SUBSCRIPTIONS_FINISHED = 'moi/simCards/ORDER_SUBSCRIPTIONS_FINISHED';

